import { z } from "zod";
import { format } from "date-fns";

const optional = () => z.string().optional().or(z.literal(""));

export const expenseFormSchema = z.object({
  expense_date: z.string().min(1, "Date is required"),
  category: z.enum([
    "salary",
    "fuel",
    "lunch",
    "client_lunch",
    "travel",
    "utilities",
    "maintenance",
    "office",
    "purchase",
    "marketing",
    "rent",
    "other",
  ]),
  title: z.string().trim().min(1, "Title is required").max(200),
  amount: z.coerce.number().positive("Amount must be greater than zero"),
  payment_method: z.enum(["cash", "upi", "card", "bank_transfer", "cheque", "other"]),
  reference: optional(),
  notes: optional(),
  client_id: optional(),
  vendor_id: optional(),
});

export type ExpenseFormValues = z.infer<typeof expenseFormSchema>;

export const emptyExpenseForm: ExpenseFormValues = {
  expense_date: format(new Date(), "yyyy-MM-dd"),
  category: "other",
  title: "",
  amount: 0,
  payment_method: "cash",
  reference: "",
  notes: "",
  client_id: "",
  vendor_id: "",
};
